import * as React from 'react';
import { FormBoxWrapper, FormBoxBox, FormBoxLabel, FormBoxInputBox, FormBoxError } from './FormBox.styles.js';

const FormBox = ({ active =false , children , label ="" , error ="" , inputName ="" , autoHeight =false , noBorder =false  })=>{
    return /*#__PURE__*/ React.createElement(FormBoxWrapper, {
        active: active,
        error: !!error
    }, /*#__PURE__*/ React.createElement(FormBoxBox, {
        autoHeight: autoHeight,
        active: active,
        error: !!error,
        noBorder: noBorder,
        htmlFor: inputName
    }, /*#__PURE__*/ React.createElement(FormBoxLabel, {
        active: active
    }, label), /*#__PURE__*/ React.createElement(FormBoxInputBox, {
        autoHeight: autoHeight,
        active: active
    }, children)), error ? /*#__PURE__*/ React.createElement(FormBoxError, null, error) : null);
};

export { FormBox };
